import { useRef, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";
import logo from "../../assets/images/logo-dark.svg";
import { FiLogOut, FiChevronRight } from "react-icons/fi";
import { MENU_CONFIG } from "../../services/menuConfig";
import { useUserAccess } from "../Context/UserAccessContext";
import useAdminLogout from "./useAdminLogout";
const Sidebar = ({ onMenuItemClicked }) => {

  const sidebarRef = useRef(null);

  const [openMenu, setOpenMenu] = useState(null);
  const navigate = useNavigate();

  const { userAccess } = useUserAccess();

  const { Logout, isLoggingOut } = useAdminLogout();
  // const menus = MENU_CONFIG.filter((menu) =>
  //   hasAccess(menu.id)
  // );

  const menus = MENU_CONFIG.filter((menu) =>
    userAccess.includes(Number(menu.id))
  );

  const handleMenuClick = (e) => {
    if (e.target.closest("a")) {
      onMenuItemClicked && onMenuItemClicked();
    }
  };

  const renderMenu = (menu) => {

    const Icon = menu.icon;

    if (!menu.children) {
      return (
        <li className="nxl-item" key={menu.id}>
          <NavLink
            to={menu.path}
            className="nxl-link"
          >
            <span className="nxl-micon">
              <Icon />
            </span>

            <span className="nxl-mtext">
              {menu.label}
            </span>
          </NavLink>
        </li>
      );
    }

    const isOpen = openMenu === menu.id;

    return (
      <li
        className={`nxl-item has-sub ${isOpen ? "open" : ""}`}
        key={menu.id}
      >

        <a
          href="#!"
          className="nxl-link"
          onClick={(e) => {
            e.preventDefault();

            setOpenMenu(
              isOpen ? null : menu.id
            );
          }}
        >

          <span className="nxl-left">

            <span className="nxl-micon">
              <Icon size={18} />
            </span>

            <span className="nxl-mtext">
              {menu.label}
            </span>

          </span>


          <span className="nxl-arrow">
            <FiChevronRight
              style={{
                width: "18px",
                height: "18px",
              }}
            />
          </span>

        </a>


        <ul className="nxl-submenu">

          {menu.children.map((child) => (

            <li
              className="nxl-item"
              key={child.path}
            >

              <NavLink
                to={child.path}
                className="nxl-link"
              >

                <span className="nxl-mtext">
                  {child.label}
                </span>

              </NavLink>

            </li>

          ))}

        </ul>

      </li>
    );
  };

  return (
    <nav className="nxl-navigation" ref={sidebarRef}>
      <div className="navbar-wrapper">

        <div className="m-header">
          <a href="/dashboard" className="b-brand">

            {/* Light logos */}
            <img src="/images/logo/logo.svg" alt="" className="logo logo-lg logo-light" />
            <img src="/images/logo/logo-sm.svg" alt="" className="logo logo-sm logo-light" />

            {/* Dark logos */}
            <img src={logo} alt="" className="logo logo-lg logo-dark" />
            {/* <img src="/images/logo/logo-sm.svg" alt="" className="logo logo-sm logo-dark" /> */}
          </a>
        </div>

        <div className="navbar-content">

          <ul className="nxl-navbar" onClick={handleMenuClick}>
            {menus.map((menu) => renderMenu(menu))}

            <li className="nxl-item">

            </li>
            <li className="nxl-item">

            </li>


            <li
              className="nxl-item"
              onClick={Logout}
              style={{
                cursor: isLoggingOut ? "not-allowed" : "pointer",
                pointerEvents: isLoggingOut ? "none" : "auto",
              }}
            >
              <NavLink
                to="#"
                className="nxl-link"
                onClick={(e) => e.preventDefault()}
              >
                <span className="nxl-micon">
                  <FiLogOut />
                </span>
                <span className="nxl-mtext">
                  {isLoggingOut ? "Logging out..." : "Logout"}
                </span>
              </NavLink>
            </li>
          </ul>

        </div>
      </div>
    </nav>
  );
};

export default Sidebar;